import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-lecture-schedule-settings',
  templateUrl: './lecture-schedule-settings.component.html',
  styleUrls: ['./lecture-schedule-settings.component.scss']
})
export class LectureScheduleSettingsComponent implements OnInit {
  showLoader: boolean = false;
  creating: boolean = false;
  dropdownSettings: any = {};
  ShowFilter = true;
  limitSelection = false;
  selectedWorkingDays: any;
  workingDaysData: any = [
    {item_id: 'saturday', item_text: this.translate.instant('SATURDAY')},
    {item_id: 'sunday', item_text: this.translate.instant('SUNDAY')},
    {item_id: 'monday', item_text: this.translate.instant('MONDAY')},
    {item_id: 'tuesday', item_text: this.translate.instant('TUESDAY')},
    {item_id: 'wednesday', item_text: this.translate.instant('WEDNESDAY')},
    {item_id: 'thursday', item_text: this.translate.instant('THURSDAY')},
    {item_id: 'friday', item_text: this.translate.instant('FRIDAY')},
  ];

  lectureScheduleSettings = new FormGroup({
    startDate: new FormControl('', [
      Validators.required,
    ]),
    endDate: new FormControl('', [
      Validators.required,
    ]),
    scheduleTimeSlot: new FormControl('', [
      Validators.required,
    ]),
    workingDays: new FormControl('', [
      Validators.required,
    ]),
    lectureStartTime: new FormControl('', [
      Validators.required,
    ]),
    maxLecturesPerDay: new FormControl('', [
      Validators.required,
    ]),
  });

  constructor(private toastrService: ToastrService, public globals: Globals, private router: Router,
    public translate: TranslateService) { }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 24,
      allowSearchFilter: this.ShowFilter
    };

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.workingDaysData = [
        {item_id: 'saturday', item_text: this.translate.instant('SATURDAY')},
        {item_id: 'sunday', item_text: this.translate.instant('SUNDAY')},
        {item_id: 'monday', item_text: this.translate.instant('MONDAY')},
        {item_id: 'tuesday', item_text: this.translate.instant('TUESDAY')},
        {item_id: 'wednesday', item_text: this.translate.instant('WEDNESDAY')},
        {item_id: 'thursday', item_text: this.translate.instant('THURSDAY')},
        {item_id: 'friday', item_text: this.translate.instant('FRIDAY')},
      ];
    });
  }

  lectureScheduleSettingsChange(){}

  lectureScheduleSettingsSubmit(){
    if (this.lectureScheduleSettings.valid) {
      // this.creating = true;
      console.log("Submit form values");
      console.log(this.lectureScheduleSettings.value);
    }
    else {
      this.lectureScheduleSettings.markAllAsTouched();
      this.lectureScheduleSettings.markAsDirty();
      this.creating = false;
    }
  }

  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }
  onSelectAll(items: any) {
    // console.log('onSelectAll', items);
  }

}
